import { motion, useScroll, useTransform } from "framer-motion";
import { useRef } from "react";
import { ArrowRight } from "lucide-react";
import { openContact } from "./ContactDialog";

export const FinalCTA = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y1 = useTransform(scrollYProgress, [0, 1], [60, -60]);
  const y2 = useTransform(scrollYProgress, [0, 1], [-40, 80]);

  return (
    <section id="contact" ref={ref} data-testid="final-cta-section"
      className="relative overflow-hidden bg-ink py-28 sm:py-40 border-t-4 border-ink">
      <motion.div style={{ y: y1 }} className="ink-dot absolute -left-32 top-10 h-[26rem] w-[26rem] bg-staxyellow" />
      <motion.div style={{ y: y2 }} className="ink-dot absolute right-[-6rem] top-32 h-96 w-96 bg-staxmagenta" />
      <div className="ink-dot absolute left-1/3 bottom-[-6rem] h-72 w-72 bg-staxcyan" />

      <div className="relative mx-auto max-w-5xl px-4 sm:px-8 text-center">
        <motion.h2
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
          className="font-display uppercase leading-[0.9] text-white"
          style={{ fontSize: "clamp(2.8rem, 8vw, 7rem)" }}
        >
          Got a brand<br />
          that needs<br />
          <span className="text-staxyellow">some Stax?</span>
        </motion.h2>
        <motion.p
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7, delay: 0.15 }}
          className="mx-auto mt-8 max-w-md text-base sm:text-lg font-medium text-white/70"
        >
          Have an idea, a project, or a brand that needs a little more personality? Let's talk.
        </motion.p>
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7, delay: 0.28 }}
        >
          <button
            data-testid="final-cta-button"
            onClick={() => openContact()}
            className="group mt-10 inline-flex items-center gap-3 border-4 border-white bg-staxmagenta px-10 py-5 font-display uppercase text-2xl text-white shadow-hard-yellow transition-transform hover:-translate-y-1.5"
          >
            Start a Project <ArrowRight size={26} className="transition-transform group-hover:translate-x-2" />
          </button>
        </motion.div>
      </div>
    </section>
  );
};
